import { styled } from '@linaria/react';
import { fonts, semantic, size, space } from '../../theme/tokens';

export const RateCodeFieldWrapper = styled.form`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: ${space['space-300']};
  padding: ${space['space-400']};
  background: ${semantic.bg.canvas};
  border: ${size.stroke['stroke-default']} solid ${semantic.border.primary};
  border-radius: ${size.radius['radius-md']};
  width: 100%;

  > *:first-child {
    flex: 1;
    min-width: 0;
  }

  input {
    padding-top: 0;
    padding-bottom: 0;
  }
`;

export const RateCodeClearButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${space['space-600']};
  height: ${space['space-600']};
  border-radius: ${size.radius['radius-full']};
  background: transparent;
  color: ${semantic.text.secondary};
  cursor: pointer;
  font-size: ${fonts.size.md};
  line-height: 1;
  padding: 0;
  border: none;
  flex-shrink: 0;

  &:hover {
    background: ${semantic.bg.surfaceSubtle};
    color: ${semantic.text.primary};
  }

  &:focus-visible {
    outline: ${size.stroke['stroke-thick']} solid ${semantic.border.selected};
    outline-offset: ${space['space-050']};
  }
`;
